import { Panel } from "../../../../components/panels/Panel";
import { ErgonomicsGraph } from "../ErgonomicsGraph";
import { useErgonomicsContext } from "../../../../contexts/ErgonomicsContext";
import { VIEW_MODE_DETAILS } from "../../../../services/ergonomics/ergonomics-service";
import { ErgonomicsNeedZoom } from "../ErgonomicsNeedZoom";

export const ErgonomicsCardDetailsGraphs = () => {
  const { viewModeLabel, zoomDateRange } = useErgonomicsContext();

  return (
    <Panel title="DONNEES OBSERVEES - DETAIL DES SCORES" subTitle={viewModeLabel} height="full">
      {
        zoomDateRange === null ? <ErgonomicsNeedZoom/> :
        <>
          <ErgonomicsGraph stepNumber={1} maxValue={3} title="Nuque" mode="zoom" />
          <ErgonomicsGraph stepNumber={2} maxValue={5} title="Tronc" mode="zoom" />
          <ErgonomicsGraph stepNumber={3} maxValue={4} title="Jambes" mode="zoom" />
          <ErgonomicsGraph stepNumber={7} maxValue={6} title="Epaule" mode="zoom" />
          <ErgonomicsGraph stepNumber={8} maxValue={2} title="Coude" mode="zoom" />
          <ErgonomicsGraph stepNumber={9} maxValue={3} title="Poignet" mode="zoom" />
        </>
      }
    </Panel>
  );
};